// import {
//     AreaChart,
//     BarChart,
//     LineChart,
//     ComposedChart,
//     PieChart,
//     RadarChart,
//     RadialBarChart,
//     ScatterChart,
//     FunnelChart,
//     Treemap,
//     ResponsiveContainer,
//     Legend,
//     Tooltip,
//     Cell,
//     Text,
//     Label,
//     LabelList,
//     Customized,
//     Area,
//     Bar,
//     Line,
//     Scatter,
//     XAxis,
//     YAxis,
//     ZAxis,
//     Brush,
//     CartesianAxis,
//     CartesianGrid,
//     ReferenceLine,
//     ReferenceDot,
//     ReferenceArea,
//     ErrorBar,
//     Funnel,
//     Cross,
//     Curve,
//     Dot,
//     Polygon,
//     Rectangle,
//     Sector,
//     Pie,
//     Radar,
//     RadialBar,
//     PolarAngleAxis,
//     PolarGrid,
//     PolarRadiusAxis,
// } from "recharts";


// // recharts scope
// export const rechartsScope = {
//     AreaChart,
//     BarChart,
//     LineChart,
//     ComposedChart,
//     PieChart,
//     RadarChart,
//     RadialBarChart,
//     ScatterChart,
//     FunnelChart,
//     Treemap,
//     ResponsiveContainer,
//     Legend,
//     Tooltip,
//     Cell,
//     Text,
//     Label,
//     LabelList,
//     Customized,
//     Area,
//     Bar,
//     Line,
//     Scatter,
//     XAxis,
//     YAxis,
//     ZAxis,
//     Brush,
//     CartesianAxis,
//     CartesianGrid,
//     ReferenceLine,
//     ReferenceDot,
//     ReferenceArea,
//     ErrorBar,
//     Funnel,
//     Cross,
//     Curve,
//     Dot,
//     Polygon,
//     Rectangle,
//     Sector,
//     Pie,
//     Radar,
//     RadialBar,
//     PolarAngleAxis,
//     PolarGrid,
//     PolarRadiusAxis,
// };


import * as ReChartComponents from 'recharts';

// Filter only actual components (functions or objects)
const reComponentNames = Object.keys(ReChartComponents).filter(
    key => typeof (ReChartComponents as any)[key] === 'function' || typeof (ReChartComponents as any)[key] === 'object'
);

// Create the scope
export const rechartsScope = reComponentNames.reduce((acc, name) => {
    acc[name] = (ReChartComponents as any)[name];
    return acc;
}, {} as Record<string, any>);